import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Support.css';

const Terms = () => {
  const [language, setLanguage] = useState('zh');

  const termsContent = {
    zh: {
      title: '使用条款与免责声明',
      content: `本网站为致力于保存经典电子游戏并向公众提供访问的非营利性项目，旨在服务于教育、历史及文化研究之目的。

我们不对任何游戏内容及相关知识产权主张所有权。所有商标、版权及相关权益均归属于各自合法权利人。我们基于"合理使用"原则及对相关内容属于公有领域或开放许可范畴的认知提供游戏ROM文件的访问权限。若您作为权利持有人认为相关内容存在不当使用，请及时联系我们以便立即移除。

用户使用本网站即表示同意以下条款：
• 仅将内容用于非商业、教育或档案目的
• 遵守包括知识产权法在内的所有适用法律法规
• 禁止未经授权对内容进行再分发、修改或提取等行为

如有任何疑问或诉求，请通过 guo.yu.29@dartmouth.edu 与我们联系。`,
      back: '返回'
    },
    en: {
      title: 'Terms of Use & Disclaimer',
      content: `This site is a nonprofit project preserving and providing public access to classic video games for educational, historical, and cultural research purposes.

We do not claim ownership of any game content, or intellectual property contained in the individual games. All trademarks, copyrights, and related rights belong to their respective owners. We provide access to game ROMs under the belief that such use constitutes fair use or falls within public domain or open license provisions. If you are a rights holder and believe your content is being used improperly, please contact us for prompt removal.

By using this site, you agree to:
• Use the content solely for non-commercial, educational, or archival purposes
• Comply with all applicable laws, including intellectual property laws
• Refrain from redistributing, modifying, or extracting content for unauthorized use

For questions or concerns, please contact us at guo.yu.29@dartmouth.edu`,
      back: 'Back'
    }
  };

  return (
    <div className="support-wrapper">
      <div className="support-container">
        <div className="support-header">
          <h1 className="weight-bold">{termsContent[language].title}</h1>
        </div>

        <div className="support-content">
          <div className="language-selector">
            <button 
              className={`language-button ${language === 'zh' ? 'active' : ''}`}
              onClick={() => setLanguage('zh')}
            >
              中文
            </button>
            <button 
              className={`language-button ${language === 'en' ? 'active' : ''}`}
              onClick={() => setLanguage('en')}
            >
              English
            </button>
          </div>

          <div className="support-section">
            <pre className={`terms-content ${language === 'en' ? 'terms-content-en' : ''}`}>
              {termsContent[language].content}
            </pre>
          </div>

          <div className="back-button-container">
            <Link to="/about" className="support-link">
              {termsContent[language].back}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms; 